import { Link } from "react-router-dom";
import PricingTable from "./layouts/PricingTable";

function Buy() {

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Pricing</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/pricing" className="text-white">Pricing</Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-0">
                <div className="container">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <div className="row g-4">
                            <div className="col-md-12">
                                <PricingTable />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Buy;